import ButtonAction from '../../common/components/Button/ButtonAction.js'
import {
  canStocktakeLabelSelector,
  lineCountSelector,
} from '../../data/stocktakes.js'
import AddStocktakeTagsDropdown from './AddStocktakeTagsDropdown.js'
import {showStocktakeModal} from './Modals/StocktakeModal.js'
import {showUpdateStocktakeStatusModal} from './Modals/UpdateStocktakeStatusModal.js'
import {getState, useSelector} from '../../store.js'
import {
  countSelector,
  isFilteredSelector,
  queryParamsSelector,
} from '../StocktakeDetailPage/stocktakeDetailFunctions.js'
import {currentPageSelector} from '../../redux/selectors/ui/index.js'
import {STOCKTAKE_DETAIL_PAGE} from '../../common/constants/Pages.js'
import {showStocktakePrintModal} from './Modals/PrintStocktakeModal.js'
import className from '../../common/className.js'
import {showStocktakeReconcileModal} from './Modals/StocktakeReconcileModal.js'
import {Count, Plural, PluralBlock} from '../../common/components/Plural.js'
import {hasProductUpdateInventoryPermissionSelector} from '../../data/me.js'

function startStocktake(referenceID) {
  const currentPage = currentPageSelector(getState())
  const query = queryParamsSelector(getState())

  showStocktakeModal({
    referenceID,
    lineQueryParams: currentPage === STOCKTAKE_DETAIL_PAGE ? query : undefined,
  })
}

function reconcileSingleStocktakeFull(referenceID, selectedSKUs) {
  const currentPage = currentPageSelector(getState())
  const query = queryParamsSelector(getState())
  const count = countSelector(getState())

  const args = {referenceID}

  if (currentPage === STOCKTAKE_DETAIL_PAGE) {
    if (selectedSKUs.length) {
      args.skus = selectedSKUs
    } else {
      args.lineQueryParams = query
      args.lineCount = count
    }
  } else {
    args.lineCount = lineCountSelector(getState(), {referenceID}).total
  }

  showStocktakeReconcileModal(args)
}

function printStocktake(referenceID) {
  const currentPage = currentPageSelector(getState())
  const query = queryParamsSelector(getState())

  showStocktakePrintModal(
    referenceID,
    currentPage === STOCKTAKE_DETAIL_PAGE ? query : undefined,
  )
}

/**
 * ActionsForSelected component renders action buttons for selected Stocktakes.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.referenceIDs - The reference IDs of the selected Stocktakes.
 * @param {Array} [props.selectedSKUs] - The selected SKUs of the stocktake from the detail page.
 *
 * @returns {React.ReactElement} The rendered component.
 */
export default function ActionsForSelected({referenceIDs, selectedSKUs = []}) {
  const canStocktakeLabel = useSelector((state) =>
    canStocktakeLabelSelector(state, {referenceID: referenceIDs[0]}),
  )
  const hasProductUpdateInventoryPermission = useSelector(
    hasProductUpdateInventoryPermissionSelector,
  )
  const currentPage = useSelector(currentPageSelector)
  const count = useSelector(countSelector)
  const isFiltered = useSelector(isFilteredSelector)
  const showStocktakeActions = selectedSKUs.length === 0
  const canReconcile =
    hasProductUpdateInventoryPermission &&
    (currentPage !== STOCKTAKE_DETAIL_PAGE ||
      selectedSKUs.length > 0 ||
      count > 0)

  return (
    <>
      {showStocktakeActions && (
        <>
          <AddStocktakeTagsDropdown referenceIDs={referenceIDs} />
          <li className="inline-block fs-n0 margin-left-10">
            <button
              className="btn btn--action v-align-base"
              type="button"
              onClick={() => showUpdateStocktakeStatusModal(referenceIDs)}
            >
              Update Status
            </button>
          </li>
        </>
      )}
      {referenceIDs.length === 1 && (
        <>
          {canStocktakeLabel && (
            <li
              className={className`inline-block fs-n0 margin-left-10 ${!showStocktakeActions && 'divider--left'}`}
            >
              <button
                className="btn btn--action v-align-base"
                type="button"
                onClick={() => startStocktake(referenceIDs[0])}
              >
                {canStocktakeLabel}
              </button>
            </li>
          )}
          {canReconcile && (
            <li className="inline-block fs-n0 margin-left-10">
              <button
                className="btn btn--action v-align-base"
                type="button"
                onClick={() =>
                  reconcileSingleStocktakeFull(referenceIDs[0], selectedSKUs)
                }
              >
                {currentPage !== STOCKTAKE_DETAIL_PAGE ? (
                  'Reconcile All'
                ) : selectedSKUs.length ? (
                  <PluralBlock array={selectedSKUs}>
                    Reconcile <Count /> <Plural word="SKU" />
                  </PluralBlock>
                ) : isFiltered ? (
                  <PluralBlock count={count}>
                    Reconcile <Count /> <Plural word="SKU" />
                  </PluralBlock>
                ) : (
                  'Reconcile All'
                )}
              </button>
            </li>
          )}
          <li className="inline-block fs-n0 margin-left-10">
            <ButtonAction onClick={() => printStocktake(referenceIDs[0])}>
              Print
            </ButtonAction>
          </li>
        </>
      )}
    </>
  )
}
